import useSWR from "swr";
import { fetcherWithToken } from "./ApiClient";

export const usePeopleToFollow = (token: string) => {
  const { data, error, mutate } = useSWR(
    token ? [`${process.env.REACT_APP_DOMAIN}/api/suggested-users/?page[size]=3`, token] : null,
    ([url, token]) => fetcherWithToken(url, token)
  );

  return {
    data: data?.results || [],
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  };
};

export const useSearchUser = ({ keyword, limit, page = 1, token }: { keyword: string; limit?: boolean; page?: number; token: string }) => {
  const shouldFetch = !!keyword && !!token;
  const pageSize = limit ? `&page[size]=20` : '';
  const pageNum = page > 1 ? `&page[number]=${page}` : '';
  const { data, error, isLoading, mutate } = useSWR(
    shouldFetch ? [`${process.env.REACT_APP_DOMAIN}/api/users/?search=${keyword}${pageSize}${pageNum}`, token] : null,
    ([url, token]) => fetcherWithToken(url, token)
  );

  return {
    data: data,
    isLoading: isLoading,
    isError: error,
    mutate: mutate,
  };
};

export const useUserStats = (userId: string, token: string) => {
  const { data, error, isLoading, mutate } = useSWR(
    userId && token ? [`${process.env.REACT_APP_DOMAIN}/api/user-stats/?user=${userId.toLowerCase()}`, token] : null,
    ([url, token]) => fetcherWithToken(url, token)
  );

  const userStats = data?.results?.[0] || null;

  return {
    data: userStats,
    isLoading: isLoading,
    isError: error,
    mutate: mutate,
  };
};

export const useUserLinks = (userId: string, token: string) => {
  const { data, error, isLoading, mutate } = useSWR(
    userId && token ? [`${process.env.REACT_APP_DOMAIN}/api/user-links/?user=${userId.toLowerCase()}`, token] : null,
    ([url, token]) => fetcherWithToken(url, token)
  );

  const userLinks = data?.results || [];

  return {
    data: userLinks,
    isLoading: isLoading,
    isError: error,
    mutate: mutate,
  };
};

export const useUserEnrollments = (userId: string, token: string, enabled: boolean = true) => {
  const shouldFetch = userId && token && enabled;

  // Build query parameters as per your iOS implementation
  const queryParams = new URLSearchParams({
    user: userId.toLowerCase(),
    sort: '-created',
    'page[number]': '1',
    'page[size]': '9'
  });

  const { data, error, isLoading, mutate } = useSWR(
    shouldFetch ? [`${process.env.REACT_APP_DOMAIN}/api/enrollments/?${queryParams.toString()}`, token] : null,
    ([url, token]) => fetcherWithToken(url, token)
  );

  const userEnrollments = data?.results || [];

  return {
    data: userEnrollments,
    isLoading: isLoading,
    isError: error,
    mutate: mutate,
  };
};

export const useUserDetails = (userId: string, token: string, enabled: boolean = true) => {
  const shouldFetch = userId && token && enabled;

  const { data, error, isLoading, mutate } = useSWR(
    shouldFetch ? [`${process.env.REACT_APP_DOMAIN}/api/users/${userId}/`, token] : null,
    ([url, token]) => fetcherWithToken(url, token)
  );

  return {
    data: data,
    isLoading: isLoading,
    isError: error,
    mutate: mutate,
  };
};